import React, { useEffect, useState, useCallback, useRef } from 'react';
import { useParams, useNavigate, useSearchParams } from 'react-router-dom';
import {
  Box,
  Typography,
  Container,
  AppBar,
  Toolbar,
  Grid,
  Paper,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  Button,
  Table,
  useMediaQuery,
  Divider,
  CardContent,
  TextField,
  Stack,
} from '@mui/material';
import { Theme, useTheme } from '@mui/material/styles';
import Slide, { SlideProps } from '@mui/material/Slide';
import PrintOutlinedIcon from '@mui/icons-material/PrintOutlined';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import { styled } from '@mui/material/styles';
import { fetchApiWithoutToken, uploadFile } from '../services/api';
// import SideMenu from '../components/SideMenu';
import { GlobalStyles as MuiGlobalStyles } from '@mui/material';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import DialogActions from '@mui/material/DialogActions';
import { fetchApi } from '../services/api';
import PhoneAndroidIcon from '@mui/icons-material/PhoneAndroid';
import DesktopWindowsIcon from '@mui/icons-material/DesktopWindows';
import ViewCompactIcon from '@mui/icons-material/ViewCompact';
import 'dayjs/locale/ko';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { ko } from 'date-fns/locale';
import EventNoteIcon from '@mui/icons-material/EventNote';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import GroupIcon from '@mui/icons-material/Group';
import ContactMailIcon from '@mui/icons-material/ContactMail';
import PersonIcon from '@mui/icons-material/Person';
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import DatePickerWrapper from '../components/DatePickerWrapper';
import PrintIcon from '@mui/icons-material/Print';
import CloseIcon from '@mui/icons-material/Close';
import { createRoot } from 'react-dom/client';
import { Helmet } from 'react-helmet-async';

interface ApiTableResponse {
  table: Itinerary[];
  table1: CityImage[];
  table2: PlaceImage[];
  table3: CompanyInfo[];
  table4: CustomInfo[];
}

interface ApiTableResponse1 {
  table: ItineraryJaon[];
}

type ItineraryJaon = {
  일정JSON: string;
};

type Itinerary = {
  일정명: string;
  내용: string;
  내업체번호: string;
  공유: boolean;
  일정번호: number;
  확정내용: string;
  안내사항: string;
} & {
  [key: string]: string | number | boolean;
};

interface CityImage {
  도시번호: number;
  도시한글명: string;
  파일경로: string;
}

interface PlaceImage {
  장소번호: number;
  장소한글명: string;
  카피라이팅: string;
  파일경로: string;
  구글맵주소: string;
}
interface CustomInfo {
  고객번호: number;
  고객명: string;
  이메일: string;
  전화번호: string;
  메세지: string;
}

interface CompanyInfo {
  대표자: string | '';
  사업자번호: string | '';
  로고경로: string | '';
  대표전화: string | '';
  대표이메일: string | '';
  우편번호: string | '';
  기본주소: string | '';
  상세주소: string | '';
  통신판매업신고번호: string | '';
  업체명: string | '';
  업체번호: string | '';
  담당자: string | '';
}

interface GroupedPlaceImage {
  장소번호: number;
  장소한글명: string;
  카피라이팅: string;
  images: string[];
  구글맵주소: string;
}

interface PrintScheduleItem {
  time?: string;
  details: string[];
  isFirst?: boolean;
  flight?: string;
}

interface PrintLocation {
  place: string;
  schedule: PrintScheduleItem[];
}

interface PrintDay {
  day: string;
  locations: {
    place: string;
    schedule: {
      time: string;
      flight: string;
      details: string[];
    }[];
  }[];
  meals: string[];
}

interface PrintData {
  title: string;
  ATTN: string;
  FROM: string;
  행사인원: string;
  TOURFEE: string;
  포함사항: string;
  불포함사항: string;
  쇼핑안내: string;
  비고: string;
  itinerary: PrintDay[];
  file_url: string;
  locations: string;
  places: string;
  상품명: string;
}

const StyledImage = styled('img')({
  width: '100%',
  height: '100%',
  objectFit: 'cover',
});

const StyledHeader = styled(AppBar)({
  width: '100vw',
  margin: 0,
  padding: 0,
  position: 'relative',
  left: '50%',
  right: '50%',
  marginLeft: '-50vw',
  marginRight: '-50vw',
  backgroundColor: 'white',
  color: 'black',
  borderBottom: '1px solid #cccccc',
});

const StyledToolbar = styled(Toolbar)({
  width: '100%',
  minHeight: '64px',
  padding: 0,
  display: 'flex',
  justifyContent: 'center',
});

const StyledFooter = styled('footer')({
  width: '99.5vw',
  margin: 0,
  padding: '24px 0',
  position: 'relative',
  left: '50%',
  right: '50%',
  marginLeft: '-51vw',
  marginRight: '-51vw',
  backgroundColor: 'background.paper',
});

const CityImageGrid = styled(Box)(({ theme }) => ({
  display: 'grid',
  gap: '5px',
  margin: '5px auto',
  width: '1280px',
  [theme.breakpoints.up('md')]: {
    gridTemplateColumns: '2fr 1fr 1fr',
    gridTemplateRows: 'auto auto',
    '& .main-image': {
      gridRow: '1 / span 2',
      height: '396px',
    },
    '& .secondary-image': {
      height: '195px',
    },
  },
  [theme.breakpoints.down('md')]: {
    gridTemplateColumns: '1fr',
    '& .main-image, & .secondary-image': {
      height: '250px',
      maxWidth: '450px', // 모바일 너비 100%로 수정
    },
  },
}));

const PrintContainer = styled(Box)({
  padding: '1mm', // 내부 여백 증가
  fontSize: '11px',
  width: '194mm',
  margin: '0 auto',
  backgroundColor: 'white',
  '@media print': {
    padding: '5mm', // 인쇄 시 내부 여백
    paddingTop: '0mm',

    margin: '0 auto',
    width: '194mm',
    minHeight: 'auto',
    height: 'auto',
    position: 'relative',
  },
});

const PrintTable = styled('table')({
  width: '100%',
  borderCollapse: 'collapse',
  fontSize: '11px',
  tableLayout: 'fixed',
  '& th, & td': {
    padding: '1px 4px',
    textAlign: 'left',
    borderBottom: '1px solid #eee',
    fontSize: '11px',
    '@media print': {
      padding: '3px 4px',
      fontSize: '11px',
      whiteSpace: 'normal',
      wordWrap: 'break-word',
      overflowWrap: 'break-word',
    },
  },
});

const ItineraryTable = styled(Table)({
  width: '100%',
  borderCollapse: 'collapse',
  '& th': {
    padding: '10px',
    textAlign: 'center',
    backgroundColor: '#f5f5f5',
    fontWeight: 'bold',
    height: '30px', // 헤더 높이 증가
  },
  '& td': {
    padding: '2px',
    textAlign: 'left',
    verticalAlign: 'top',
    lineHeight: '1.4', // 줄 간격 증가
  },
  '@media print': {
    pageBreakInside: 'auto',
    '& tr': {
      pageBreakInside: 'avoid',
      pageBreakAfter: 'auto',
    },
  },
});

const StyledDialogContent = styled(DialogContent)({
  padding: '8mm',
  backgroundColor: 'white',
  '@media print': {
    padding: '8mm',
    minHeight: 'auto',
    height: 'auto',
  },
});

const StyledDialog = styled(Dialog)({
  '@media print': {
    '& .MuiDialog-paper': {
      margin: '0 auto',
      width: '210mm !important',
      minHeight: 'auto',
      height: 'auto',
      boxShadow: 'none',
      backgroundColor: 'white',
    },
  },
});

const ButtonContainer = styled(Box)({
  display: 'flex',
  justifyContent: 'flex-end',
  gap: '8px',
  marginBottom: '16px',
  '@media print': {
    display: 'none',
  },
});

const ContentTypography = styled(Typography)({
  '@media print': {
    whiteSpace: 'normal',
    wordWrap: 'break-word',
    overflowWrap: 'break-word',
  },
});

const BASE_IMAGE_URL = 'https://kr.object.iwinv.kr/1024/';

const getImageUrl = (path: string) => {
  if (!path) return '';
  return `${BASE_IMAGE_URL}${path}`;
};

const GlobalStyles = styled('div')(({ theme }) => ({
  [theme.breakpoints.down('md')]: {
    '& body': {
      padding: 0,
      margin: 0,
    },
  },
  '@media print': {
    '& .MuiAppBar-root': {
      display: 'none',
    },
    '& .MuiContainer-root': {
      padding: '30mm',
      margin: 0,
      width: '210mm',
      minHeight: 'auto',
    },
    '& .print-content': {
      breakInside: 'avoid',
      pageBreakInside: 'avoid',
    },
  },
}));

const PrintGlobalStyles = () => (
  <MuiGlobalStyles
    styles={{
      '@media print': {
        '@page': {
          size: 'A4',
          margin: '10mm 0',
        },
        'html, body': {
          margin: 0,
          padding: 0,
          width: '210mm',
          backgroundColor: 'white',
          height: 'auto',
        },
        // 인쇄 시 불필요한 요소 숨기기
        '.MuiAppBar-root, .no-print': {
          display: 'none !important',
        },
        '.print-area': {
          display: 'block !important',
          position: 'relative !important',
          overflow: 'visible !important',
          height: 'auto !important',
          pageBreakInside: 'avoid',
        },
      },
    }}
  />
);

const ReservationCard = styled(Paper)(({ theme }) => ({
  position: 'sticky',
  top: '20px',
  width: '324px',
  borderRadius: '12px',
  boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
  border: '1px solid rgba(0, 0, 0, 0.05)',
  overflow: 'hidden',
  background: 'linear-gradient(180deg, #FFFFFF 0%, #FAFAFA 100%)',
}));

const StyledTextField = styled(TextField)({
  '& .MuiOutlinedInput-root': {
    height: '40px',
    '& fieldset': {
      borderColor: '#e0e0e0',
    },
    '&:hover fieldset': {
      borderColor: '#1976d2',
    },
    '&.Mui-focused fieldset': {
      borderColor: '#1976d2',
    },
  },
});

interface ReservationForm {
  dateRange: [Date | null, Date | null];
  성인수: number;
  소아수: number;
  유아수: number;
  요청자명: string;
  요청자휴대폰: string;
  요청자이메일: string;
  견적내용: string;
}

const MobileReservationButton = styled(Button)(({ theme }) => ({
  position: 'fixed',
  bottom: 0,
  left: 0,
  width: '100%',
  height: '56px',
  borderRadius: '0',
  fontSize: '16px',
  fontWeight: 'bold',
  zIndex: 1000,
  display: 'none',
  [theme.breakpoints.down('sm')]: {
    display: 'flex',
  },
}));

const MobileReservationDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialog-paper': {
    margin: 0,
    width: '100%',
    maxWidth: '100%',
    position: 'fixed',
    bottom: 0,
    borderRadius: '16px 16px 0 0',
    maxHeight: 'calc(100% - 56px)',
  },
}));

// 날짜 포맷팅 함수 추가
const formatDate = (date: Date | null): string | null => {
  if (!date) return null;
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(
    2,
    '0'
  )}`;
};

// 전화번호 포맷팅 함수 추가
const formatPhoneNumber = (phone: string) => {
  if (!phone) return '';

  // 숫자만 추출
  const numbers = phone.replace(/[^0-9]/g, '');

  // 길이에 따라 다르게 포맷팅
  if (numbers.length === 11) {
    return `${numbers.slice(0, 3)}-${numbers.slice(3, 7)}-${numbers.slice(7)}`;
  } else if (numbers.length === 10) {
    return `${numbers.slice(0, 3)}-${numbers.slice(3, 6)}-${numbers.slice(6)}`;
  } else if (numbers.length === 9) {
    return `${numbers.slice(0, 2)}-${numbers.slice(2, 5)}-${numbers.slice(5)}`;
  }

  return phone; // 포맷팅할 수 없는 경우 원본 반환
};

const PreviewPage: React.FC = () => {
  const { itnNo } = useParams<{ itnNo: string }>();
  const [searchParams] = useSearchParams();
  const companyId = searchParams.get('companyId');
  const customId = searchParams.get('customId');
  const [itinerary, setItinerary] = useState<Itinerary | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [cityImages, setCityImages] = useState<CityImage[]>([]);
  const [placeImages, setPlaceImages] = useState<PlaceImage[]>([]);
  const [companyInfo, setCompanyInfo] = useState<CompanyInfo | null>(null);
  const [customInfo, setCustomInfo] = useState<CustomInfo | null>(null);
  const [groupedPlaceImages, setGroupedPlaceImages] = useState<GroupedPlaceImage[]>([]);
  const [printData, setPrintData] = useState<PrintData | null>(null);
  const [printFontSize, setPrintFontSize] = useState(11);
  const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'));
  const [isCompactView, setIsCompactView] = useState(false);
  
  const [reservationForm, setReservationForm] = useState<ReservationForm>({
    dateRange: [null, null],
    성인수: 0,
    소아수: 0,
    유아수: 0,
    요청자명: '',
    요청자휴대폰: '',
    요청자이메일: '',
    견적내용: '',
  });
  const [mobileReservationOpen, setMobileReservationOpen] = useState(false);
  const theme = useTheme();
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const handleFontSizeChange = (increase: boolean) => {
    setPrintFontSize((prev) => (increase ? prev + 1 : prev - 1));
  };

  const [stickyTop, setStickyTop] = useState<number | null>(null);
  const reservationCardRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleScroll = () => {
      if (reservationCardRef.current) {
        const rect = reservationCardRef.current.getBoundingClientRect();
        if (rect.top <= 20) {
          setStickyTop(20); // sticky 상태일 때
        } else {
          setStickyTop(rect.top); // 일반 상태일 때
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    const fetchItinerary = async () => {
      try {
        if (!itnNo) {
          throw new Error('일정번호가 없습니다.');
        }

        const postData = [
          { 컬럼명: '@일정번호', 값: itnNo },
          { 컬럼명: '@공유여부', 값: 1 },
        ];

        if (companyId) {
          postData.push({ 컬럼명: '@거래처번호', 값: companyId });
        }

        if (customId) {
          postData.push({ 컬럼명: '@고객번호', 값: customId });
        }

        // counselingId가 있는 경우 상담번호 추가
        const counselingId = new URLSearchParams(window.location.search).get('counselingId');
        
        if (counselingId) {
          postData.push({ 컬럼명: '@상담번호', 값: counselingId });
        }
        
        const response = await fetchApiWithoutToken<ApiTableResponse>('ITN_S_일정표1', postData);

        if (response.data && response.data.table && response.data.table.length > 0) {
          setItinerary(response.data.table[0]);
          setCityImages(response.data.table1);
          setPlaceImages(response.data.table2);
          setCompanyInfo(response.data.table3[0]);
          if (customId) {
            setCustomInfo(response.data.table4[0]);
          }
        } else {
          throw new Error('일정표를 찾을 수 없습니다.');
        }
      } catch (error) {
        console.error('Failed to fetch itinerary:', error);
        setError(error instanceof Error ? error.message : '일정표를 불러오는데 실패했습니다.');
      } finally {
        setLoading(false);
      }
    };

    fetchItinerary();
  }, [itnNo, companyId]);

  useEffect(() => {
    // Group place images by 장소번호
    const groupImages = () => {
      const grouped = placeImages.reduce((acc: GroupedPlaceImage[], curr) => {
        const existingGroup = acc.find((g) => g.장소번호 === curr.장소번호);
        if (existingGroup) {
          existingGroup.images.push(curr.파일경로);
          return acc;
        }
        return [
          ...acc,
          {
            장소번호: curr.장소번호,
            장소한글명: curr.장소한글명,
            카피라이팅: curr.카피라이팅,
            images: [curr.파일경로],
            구글맵주소: curr.구글맵주소,
          },
        ];
      }, []);
      setGroupedPlaceImages(grouped);
    };

    if (placeImages && placeImages.length > 0) {
      groupImages();
    }
  }, [placeImages]);

  useEffect(() => {
    // HTML 콘텐츠에 포함된 스크립트 실행
    const executeScripts = () => {
      // 기존 요소와 스크립트 제거
      const existingElements = document.querySelectorAll('[id^="dayTitle"]');
      existingElements.forEach((el) => el.remove());

      const existingScripts = document.querySelectorAll('script[data-itinerary]');
      existingScripts.forEach((script) => script.remove());

      // 새로운 스크립트 추가
      const scripts = document.querySelectorAll('script:not([data-itinerary])');
      scripts.forEach((script) => {
        const scriptContent = script.textContent;
        if (scriptContent) {
          try {
            const cleanedContent = scriptContent.replace(/const\s+dayTitles/g, 'var dayTitles');
            script.remove();
            const newScript = document.createElement('script');
            newScript.type = 'text/javascript';
            newScript.setAttribute('data-itinerary', 'true');
            newScript.async = true;
            newScript.text = cleanedContent;
            document.head.appendChild(newScript);
          } catch (error) {
            console.error('Error executing script:', error);
          }
        }
      });
    };

    // 컴포넌트가 마운트된 후에만 스크립트 실행
    if (typeof window !== 'undefined' && itinerary) {
      executeScripts();
    }

    // Cleanup function
    return () => {
      const existingElements = document.querySelectorAll('[id^="dayTitle"]');
      existingElements.forEach((el) => el.remove());
      const existingScripts = document.querySelectorAll('script[data-itinerary]');
      existingScripts.forEach((script) => script.remove());
    };
  }, [itinerary]);

  const handlePrintClick = async () => {
    try {
      const postData = [{ 컬럼명: '@일정번호', 값: itnNo }];
      const response = await fetchApiWithoutToken<ApiTableResponse1>('ITN_S_일정표_출력', postData);

      if (response.data && response.data.table && response.data.table.length > 0) {
        const printData = JSON.parse(response.data.table[0].일정JSON);
        // 프린트 페이지로 이동
        navigate('/print', { 
          state: { 
            printData,
            itinerary 
          }
        });
      } else {
        throw new Error('인쇄할 일정표를 찾을 수 없습니다.');
      }
    } catch (error) {
      console.error('Failed to fetch print data:', error);
      setError(error instanceof Error ? error.message : '인쇄용 일정표를 불러오는데 실패했습니다.');
    }
  };

  const handleReservationSubmit = async () => {
    try {
      const postData = [
        {
          컬럼명: '@상담정보',
          값: JSON.stringify({
            견적경로: '421003',
            상담구분: '419001',
            상담상태: '420001',
            상담번호: 0,
            담당자: '',
            담당자번호: itinerary?.내유저번호 || 0,
            판매업체: companyInfo?.업체명 || '',
            판매업체번호: companyInfo?.업체번호 || 0,
            수배처: itinerary?.업체명 || '',
            수배처번호: itinerary?.업체번호 || 0,
            요청자명: reservationForm.요청자명,
            요청자휴대폰: reservationForm.요청자휴대폰,
            요청자이메일: reservationForm.요청자이메일,
            시작일: formatDate(reservationForm.dateRange[0]),
            종료일: formatDate(reservationForm.dateRange[1]),
            견적명: itinerary?.일정명 || '',
            견적내용: reservationForm.견적내용,
            성인수: reservationForm.성인수,
            소아수: reservationForm.소아수,
            유아수: reservationForm.유아수,
            인솔자수: 0,
            성인판매가: 0,
            소아판매가: 0,
            유아판매가: 0,
            성인원가: 0,
            소아원가: 0,
            유아원가: 0,
            고객명단: '',
            입금총액: 0,
            출금총액: 0,
            일정표주소: window.location.href,
            일정번호: itinerary?.일정번호 || 0,
          }),
        },
        {
          컬럼명: '@처리자',
          값: localStorage.getItem('UserNo') ? localStorage.getItem('UserNo') : itinerary?.내유저번호 || 0,
        },
        {
          컬럼명: '@업체번호',
          //  토큰이 있을때는 토큰 없체가 상담주체,  없을때는 공유한 업체가 상담주체
          값: localStorage.getItem('CompanyNo') ? localStorage.getItem('CompanyNo') : companyInfo?.업체번호 || '0',
        },
      ];
      const response = await fetchApiWithoutToken('DBO.ITN_T_상담저장', postData);

      if (response.data) {
        alert('예약신청이 완료되었습니다.');
        setReservationForm({
          dateRange: [null, null],
          성인수: 0,
          소아수: 0,
          유아수: 0,
          요청자명: '',
          요청자휴대폰: '',
          요청자이메일: '',
          견적내용: '',
        });
      }
    } catch (error) {
      console.error('예약신청 실패:', error);
      alert('예약신청에 실패했습니다.');
    }
  };

  // 예약 신청하기 버튼 활성화 조건
  const isReservationButtonEnabled = () => {
    const { dateRange, 성인수, 소아수, 유아수, 요청자명, 요청자휴대폰, 요청자이메일 } = reservationForm;
    const isDateRangeSelected = dateRange[0] !== null && dateRange[1] !== null;
    const isPersonCountValid = 성인수 + 소아수 + 유아수 > 0;
    const isNameFilled = 요청자명.trim() !== '';
    const isContactInfoFilled = 요청자휴대폰.trim() !== '' || 요청자이메일.trim() !== '';

    return isDateRangeSelected && isPersonCountValid && isNameFilled && isContactInfoFilled;
  };

  const navigate = useNavigate();
  const [shareConfirmDialog, setShareConfirmDialog] = useState(false);
  const [snackbar, setSnackbar] = useState<{ open: boolean; message: string; severity: 'success' | 'error' }>({
    open: false,
    message: '',
    severity: 'success',
  });

  const handleConfirmShare = async () => {
    const token = localStorage.getItem('token');
    const companyNo = localStorage.getItem('CompanyNo');

    if (!token || !companyNo) {
      setShareConfirmDialog(false);
      navigate('/login');
      return;
    }

    try {
      const postData = [
        { 컬럼명: '@업체번호', 값: localStorage.getItem('CompanyNo') },
        { 컬럼명: '@일정번호', 값: itnNo },
        { 컬럼명: '@유저번호', 값: localStorage.getItem('UserNo') },
      ];
      const response = await fetchApi('ITN_T_간편일정공유', postData);

      if (response.data) {
        setSnackbar({
          open: true,
          message: '일정표가 내 일정표에 추가되었습니다.',
          severity: 'success',
        });
      }
    } catch (error) {
      setSnackbar({
        open: true,
        message: '일정표 가져오기에 실패했습니다.',
        severity: 'error',
      });
    } finally {
      setShareConfirmDialog(false);
    }
  };

  const handleCancelShare = () => {
    setShareConfirmDialog(false);
  };

  // 사이드 메뉴 표시 여부 결정
  // const shouldShowSideMenu = !companyId && itinerary?.내업체번호 === itinerary?.업체번호;

  // PC 버전으로 이동하는 함수
  const handlePCView = () => {
    navigate(`/preview-pc/${itnNo}`);
  };

  // counselingId 파라미터 가져오기
  const counselingId = new URLSearchParams(window.location.search).get('counselingId');

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <Typography>로딩중...</Typography>
      </Box>
    );
  }

  if (error || !itinerary) {
    return (
      <Box sx={{ display: 'flex' }}>
        {/* {itinerary?.공유 && <SideMenu mobileOpen={mobileOpen} handleDrawerToggle={handleDrawerToggle} />} */}
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
          <Typography color="error">{error || '일정표를 찾을 수 없습니다.'}</Typography>
        </Box>
      </Box>
    );
  }

  return (
    <Box sx={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <Helmet>
        {cityImages && cityImages.length > 0 && (
          <meta 
            property="og:image" 
            content={getImageUrl(cityImages[0].파일경로).replace('1024', 'orgin')} 
          />
        )}
        {itinerary?.일정명 && (
          <meta 
            property="og:title" 
            content={itinerary.일정명} 
          />
        )}
      </Helmet>

      <GlobalStyles />
      <PrintGlobalStyles />

      {/* counselingId가 없을 때만 SideMenu 표시 */}
      {/* {!counselingId && (
        <SideMenu 
          mobileOpen={mobileOpen} 
          handleDrawerToggle={handleDrawerToggle} 
        />
      )} */}

      <StyledHeader
        position="static"
        elevation={0}
        sx={{ 
          height: { xs: 'auto', md: 64 },  // PC 버전 높이를 64px로 변경
          pt: { md: 1.5 },
        }}>
        <StyledToolbar>
          <Box
            sx={{
              width: { xs: '100%', md: '1280px' },
              height: '100%',
              display: 'flex',
              justifyContent: 'space-between',
              px: { xs: 2, md: 0 },
              py: { xs: 2, md: 0 },
            }}>
            {/* 왼쪽: 로고와 회사 정보 영역 */}
            <Box sx={{ flex: 1 }}>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: { xs: 'column', md: 'row' },
                  alignItems: { xs: 'flex-start', md: 'center' },
                  gap: { xs: 1, md: 2 }
                }}>
                {/* 로고 영역 */}
                <Box>
                  {companyInfo?.로고경로 ? (
                    <img
                      src={getImageUrl(companyInfo.로고경로).replace('1024', 'orgin')}
                      alt={companyInfo.업체명}
                      style={{
                        height: companyId && isMobile ? '28px' : '36px',
                        maxWidth: '200px',
                        objectFit: 'contain'
                      }}
                    />
                  ) : (
                    <Typography variant="h6" sx={{ fontSize: '18px', fontWeight: 'bold' }}>
                      {companyInfo?.업체명}
                    </Typography>
                  )}
                </Box>

                {/* 대표자명과 전화번호 영역 */}
                {companyId && (
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: 2
                    }}>
                    <Typography
                      sx={{
                        fontSize: { xs: '14px', md: '16px' },
                        fontWeight: 700,
                      }}>
                      {companyInfo?.대표자}
                    </Typography>
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '4px',
                      }}>
                      <PhoneIcon
                        sx={{
                          fontSize: { xs: '14px', md: '16px' },
                          color: 'primary.main',
                        }}
                      />
                      <Typography
                        sx={{
                          fontSize: { xs: '14px', md: '16px' },
                          fontWeight: 700,
                        }}>
                        {formatPhoneNumber(companyInfo?.대표전화 || '')}
                      </Typography>
                    </Box>
                  </Box>
                )}
              </Box>
            </Box>

            {/* 오른쪽: 간략보기 버튼 */}
            <Box sx={{ display: 'flex', alignItems: 'flex-start' , pt: { xs: 1, md: 0 } }}>
              <Button
                variant="contained"
                onClick={handlePrintClick}
                startIcon={isMobile ? <ViewCompactIcon /> : <PrintIcon />}
                sx={{
                  color: 'text.primary',
                  minWidth: { xs: '100px', md: '125px' },
                  height: '36px',
                  bgcolor: isCompactView ? 'action.selected' : 'transparent',
                  '&:hover': {
                    bgcolor: isCompactView ? 'action.selected' : 'action.hover',
                  },
                  whiteSpace: 'nowrap',
                }}>
                {isMobile ? '간략보기' : '인쇄'}
              </Button>
            </Box>
          </Box>
        </StyledToolbar>
      </StyledHeader>

      <Box
        sx={{
          display: 'flex',
          width: '100%',
          position: 'relative',
          // companyId가 있을 때는 사이드메뉴 여백 제거
          // ml: shouldShowSideMenu ? { sm: '240px' } : 0
        }}>
        {/* Main Content Container */}
        <Container
          maxWidth={false}
          sx={{
            flex: 1,
            px: '0 !important',
            py: '16px',
            '@media print': {
              display: 'none',
            },
            position: 'relative',
            left: '50%',
            transform: 'translateX(-50%)',
            width: '1280px',
            [theme.breakpoints.down('sm')]: {
              width: '100%',
              left: 0,
              transform: 'none',
              // px: '16px !important'
            },
          }}>
          {/* City Images Section - Full Width */}
          <Box
            sx={{
              width: '100%',
              // margin: '0 auto',
              // overflow: 'hidden'
            }}>
            <pre
              style={{
                fontSize: '14px',
                fontFamily: 'Pretendard',
                fontWeight: 700,
                color: 'text.secondary',
                display: customId ? 'block' : 'none',
              }}>
              {customInfo?.메세지 ? customInfo.메세지 : `TO: ${customInfo?.고객명}님`}
            </pre>

            <Divider sx={{ mb: 1, display: customId ? 'block' : 'none' }} />
            {/* {isMobile && (
              <Button variant="contained" color="primary" onClick={handlePDF}>PDF로 보기</Button>
            )} */}

            {/* 모바일에서만 보이는 토글 버튼
            {isMobile && (
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  py: 0,
                  // borderBottom: '1px solid',
                  // borderColor: 'divider',
                  // bgcolor: 'background.paper'
                }}>
                <Button
                  variant="outlined"
                  startIcon={<PhoneAndroidIcon />}
                  onClick={handlePCView}
                  sx={{
                    width: '180px',
                    height: '40px',
                    mr: 1,
                    bgcolor: 'primary.main',
                    color: 'white',
                    '&:hover': {
                      bgcolor: 'primary.dark',
                    },
                  }}>
                  PC 버전으로 보기
                </Button>
              </Box>
            )} */}
            <CityImageGrid>
              {cityImages &&
                cityImages.length > 0 &&
                cityImages.slice(0, 5).map((city, index) => (
                  <Box
                    key={index}
                    className={index === 0 ? 'main-image' : 'secondary-image'}
                    sx={{
                      display: {
                        xs: index === 0 ? 'block' : 'none',
                        md: 'block',
                      },
                    }}>
                    <StyledImage src={getImageUrl(city.파일경로)} alt={city.도시한글명}  />
                  </Box>
                ))}
            </CityImageGrid>
          </Box>

          {/* Content Wrapper */}
          <Box
            sx={{
              display: 'flex',
              gap: 3,
              margin: '0 auto',
              width: '1280px',
              [theme.breakpoints.down('sm')]: {
                width: '100%',
                flexDirection: 'column',
              },
            }}>
            {/* Main Content - 930px */}
            <Box
              sx={{
                width: '930px',
                [theme.breakpoints.down('sm')]: {
                  width: '100%',
                  mb: '72px',
                },
              }}>
              {/* Itinerary Content */}
              <Paper elevation={0} sx={{ border: '1px solid #eee', borderRadius: 4 , p: 2, mt: 3.5}}>
                  <Typography
                    sx={{ fontSize: '18px', fontWeight: 'bold',  mb: 2, borderBottom: '2px solid #aaa' }}>
                    {itinerary.일정명}
                  </Typography>
                  {itinerary.확정내용 && (
                    <Box sx={{  mb: 2 }}>
                      <Typography variant="subtitle1" sx={{ fontWeight: 'bold', color: 'primary.main', mb: 1, fontSize: '14px' }}>
                        확정 내용
                      </Typography>
                      <Typography 
                        variant="body1" 
                        sx={{ 
                          whiteSpace: 'pre-wrap', 
                          bgcolor: 'grey.50', 
                          p: 2, 
                          borderRadius: 3,
                          fontSize: '14px'
                        }}>
                        {itinerary.확정내용}
                      </Typography>
                    </Box>
                  )}
                  
                  {itinerary.안내사항 && (
                    <Box sx={{  mb: 2 }}>
                      <Typography variant="subtitle1" sx={{ fontWeight: 'bold', color: 'primary.main', mb: 1, fontSize: '14px' }}>
                        안내 사항
                      </Typography>
                      <Typography 
                        variant="body1" 
                        sx={{ 
                          whiteSpace: 'pre-wrap', 
                          bgcolor: 'grey.50', 
                          p: 2, 
                          borderRadius: 4,
                          fontSize: '14px'
                        }}>
                        {itinerary.안내사항}
                      </Typography>
                    </Box>
                  )}
              </Paper>
              <Box sx={{ mt: 2 }}>
                <ContentTypography>
                  <Box dangerouslySetInnerHTML={{ __html: itinerary.내용 }} />
                </ContentTypography>
              </Box>
              {/* Place Images Section */}
              <Box sx={{ mt: 4 }}>
                <Grid container spacing={3}>
                  {groupedPlaceImages.map((place, index) => (
                    <Grid item xs={12} key={index}>
                      <Paper elevation={0} sx={{ border: '1px solid #eee', borderRadius: 2 }}>
                        <Box sx={{ py: 2, px: 4, borderRadius: 3 }}>
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 1 }}>
                            <Typography variant="subtitle1">{place.장소한글명}</Typography>
                            {/* <Button
                              variant="contained"
                              size="small"
                              sx={{
                                height: '24px',
                                minHeight: '24px',
                                padding: '0px 8px',
                                fontSize: '0.75rem'
                              }}
                              onClick={() => {
                                const width = 1200;
                                const height = 600;
                                const left = (window.screen.width - width) / 2;
                                const top = (window.screen.height - height) / 2;
                                window.open(
                                  place.구글맵주소,
                                  '_blank',
                                  `width=${width},height=${height},top=${top},left=${left}`
                                );
                              }}
                            >
                              지도보기
                            </Button> */}
                          </Box>

                          <Grid container spacing={1}>
                            {place.images.slice(0, 3).map((imagePath, imgIndex) => (
                              <Grid item xs={12} sm={4} key={imgIndex}>
                                <Box sx={{ height: 150 }}>
                                  <StyledImage
                                    src={getImageUrl(imagePath)}
                                    alt={`${place.장소한글명} ${imgIndex + 1}`}
                                  />
                                </Box>
                              </Grid>
                            ))}
                          </Grid>
                          <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                            {place.카피라이팅}
                          </Typography>
                        </Box>
                      </Paper>
                    </Grid>
                  ))}
                </Grid>
              </Box>
            </Box>

            {/* Reservation Card - 324px */}
            {!isMobile && (
              <ReservationCard sx={{ mt: 3.5 }} ref={reservationCardRef}>
                <CardContent sx={{ p: 3, mt: 1 }}>
                  <Box sx={{ mb: 3, textAlign: 'center' }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', mb: 1 }}>
                      <EventNoteIcon sx={{ color: '#37474F', mr: 1 }} />
                      <Typography variant="h6" sx={{ fontWeight: 700 }}>
                        여행 일정 예약
                      </Typography>
                    </Box>
                    <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                      <br />
                      신청하시면 전문 상담원이 빠르게 연락드립니다
                    </Typography>
                  </Box>

                  <Stack spacing={2.5}>
                    <Box>
                      <Typography variant="subtitle2" sx={{ mb: 1, color: '#37474F', fontWeight: 700 }}>
                        <CalendarTodayIcon sx={{ fontSize: 16, mr: 0.5, verticalAlign: 'text-bottom' }} />
                        기간 선택<span style={{ color: 'red' }}>*</span>
                      </Typography>
                      <DatePickerWrapper>
                        <DatePicker
                          selectsRange
                          monthsShown={isMobile ? 1 : 2}
                          startDate={reservationForm.dateRange[0]}
                          endDate={reservationForm.dateRange[1]}
                          onChange={(update: [Date | null, Date | null]) => {
                            setReservationForm((prev) => ({
                              ...prev,
                              dateRange: update,
                            }));
                            if (update[1]) {
                              setTimeout(() => {
                                const element = document.querySelector('.react-datepicker__input-container input');
                                if (element) {
                                  (element as HTMLElement).blur();
                                }
                              }, 100);
                            }
                          }}
                          dateFormat="yyyy/MM/dd"
                          locale={ko}
                          minDate={new Date()}
                          isClearable
                          showPopperArrow={false}
                          calendarStartDay={1}
                          customInput={<TextField fullWidth size="small" />}
                          dayClassName={(date) => {
                            const today = new Date();
                            if (date.toDateString() === today.toDateString()) {
                              return 'today-date';
                            } else if (date < today) {
                              return 'past-date';
                            }
                            return '';
                          }}
                        />
                      </DatePickerWrapper>
                    </Box>

                    <Box>
                      <Typography variant="subtitle2" sx={{ mb: 2, color: '#37474F', fontWeight: 700 }}>
                        <GroupIcon sx={{ fontSize: 16, mr: 0.5, verticalAlign: 'text-bottom' }} />
                        인원 구성 <span style={{ color: 'red' }}>*</span>
                      </Typography>
                      <Stack direction="row" spacing={1}>
                        <StyledTextField
                          label="성인"
                          type="number"
                          value={reservationForm.성인수}
                          onChange={(e) =>
                            setReservationForm((prev) => ({
                              ...prev,
                              성인수: parseInt(e.target.value) || 0,
                            }))
                          }
                          InputProps={{
                            // startAdornment: <PersonIcon sx={{ color: 'action.active', mr: 1, fontSize: 20 }} />,
                            inputProps: { min: 0 },
                          }}
                        />
                        <StyledTextField
                          label="소아"
                          type="number"
                          value={reservationForm.소아수}
                          onChange={(e) =>
                            setReservationForm((prev) => ({
                              ...prev,
                              소아수: parseInt(e.target.value) || 0,
                            }))
                          }
                          InputProps={{
                            // startAdornment: <PersonIcon sx={{ color: 'action.active', mr: 1, fontSize: 20 }} />,
                            inputProps: { min: 0 },
                          }}
                        />
                        <StyledTextField
                          label="유아"
                          type="number"
                          value={reservationForm.유아수}
                          onChange={(e) =>
                            setReservationForm((prev) => ({
                              ...prev,
                              유아수: parseInt(e.target.value) || 0,
                            }))
                          }
                          InputProps={{
                            // startAdornment: <PersonIcon sx={{ color: 'action.active', mr: 1, fontSize: 20 }} />,
                            inputProps: { min: 0 },
                          }}
                        />
                      </Stack>
                    </Box>

                    <Box>
                      <Typography variant="subtitle2" sx={{ mb: 1, color: '#37474F', fontWeight: 700 }}>
                        <ContactMailIcon sx={{ fontSize: 16, mr: 0.5, verticalAlign: 'text-bottom' }} />
                        연락처 정보 <span style={{ color: 'red' }}>*</span>
                      </Typography>
                      <Stack spacing={1.5}>
                        <StyledTextField
                          placeholder="이름을 입력해주세요"
                          value={reservationForm.요청자명}
                          onChange={(e) =>
                            setReservationForm((prev) => ({
                              ...prev,
                              요청자명: e.target.value,
                            }))
                          }
                          InputProps={{
                            startAdornment: <PersonIcon sx={{ color: 'action.active', mr: 1, fontSize: 20 }} />,
                          }}
                        />
                        <StyledTextField
                          placeholder="연락받으실 전화번호를 입력해주세요"
                          value={reservationForm.요청자휴대폰}
                          onChange={(e) =>
                            setReservationForm((prev) => ({
                              ...prev,
                              요청자휴대폰: e.target.value,
                            }))
                          }
                          InputProps={{
                            startAdornment: <PhoneIcon sx={{ color: 'action.active', mr: 1, fontSize: 20 }} />,
                          }}
                        />
                        <StyledTextField
                          placeholder="이메일 주소를 입력해주세요"
                          value={reservationForm.요청자이메일}
                          onChange={(e) =>
                            setReservationForm((prev) => ({
                              ...prev,
                              요청자이메일: e.target.value,
                            }))
                          }
                          InputProps={{
                            startAdornment: <EmailIcon sx={{ color: 'action.active', mr: 1, fontSize: 20 }} />,
                          }}
                        />
                      </Stack>
                    </Box>

                    <TextField
                      placeholder="추가 요청사항이나 문의사항을 입력해주세요"
                      multiline
                      rows={3}
                      value={reservationForm.견적내용}
                      onChange={(e) =>
                        setReservationForm((prev) => ({
                          ...prev,
                          견적내용: e.target.value,
                        }))
                      }
                      sx={{
                        '& .MuiOutlinedInput-root': {
                          backgroundColor: 'rgba(0, 0, 0, 0.02)',
                          fontSize: '14px',
                          p: 0,
                        },
                      }}
                    />

                    <Button
                      variant="contained"
                      fullWidth
                      size="large"
                      onClick={handleReservationSubmit}
                      sx={{
                        height: '48px',
                        fontSize: '16px',
                        fontWeight: 'bold',
                      }}
                      disabled={!isReservationButtonEnabled()}
                      endIcon={<ArrowForwardIcon />}>
                      예약 신청하기
                    </Button>
                  </Stack>
                </CardContent>
              </ReservationCard>
            )}
          </Box>
        </Container>
      </Box>

      {/* Footer */}
      <StyledFooter sx={{ bgcolor: 'background.paper', mt: '20px', borderTop: '1px solid #ccc', height: '180px' }}>
        <Container maxWidth="lg">
          {companyInfo && (
            <Typography
              variant="body2"
              color="text.secondary"
              align="center"
              bgcolor={'background.paper'}
              lineHeight={2.1}>
              {companyInfo.업체명 && `${companyInfo.업체명}`}
              {companyInfo.대표자 && ` | ${companyInfo.대표자}`}
              {companyInfo.사업자번호 && ` | 사업자번호: ${companyInfo.사업자번호}`}
              <br />
              {(companyInfo.우편번호 || companyInfo.기본주소 || companyInfo.상세주소) &&
                `주소: ${companyInfo.우편번호 ? `(${companyInfo.우편번호})` : ''} ${companyInfo.기본주소 || ''} ${
                  companyInfo.상세주소 || ''
                }`}
              {(companyInfo.우편번호 || companyInfo.기본주소 || companyInfo.상세주소) && <br />}
              {(companyInfo.대표전화 || companyInfo.대표이메일) && (
                <>
                  {companyInfo.대표전화 && `대표전화: ${companyInfo.대표전화}`}
                  {companyInfo.대표전화 && companyInfo.대표이메일 && ' | '}
                  {companyInfo.대표이메일 && `이메일: ${companyInfo.대표이메일}`}
                  <br />
                </>
              )}
              {companyInfo.통신판매업신고번호 && `통신판매업신고번호: ${companyInfo.통신판매업신고번호}`}
            </Typography>
          )}
        </Container>
      </StyledFooter>

      {isMobile && (
        <MobileReservationButton variant="contained" onClick={() => setMobileReservationOpen(true)}>
          날짜 및 인원선택
        </MobileReservationButton>
      )}

      <MobileReservationDialog
        open={isMobile && mobileReservationOpen}
        onClose={() => setMobileReservationOpen(false)}
        TransitionComponent={Slide}
        TransitionProps={
          {
            direction: 'up',
          } as SlideProps
        }>
        <DialogContent>
          <Stack spacing={2}>
            <Typography variant="h6" gutterBottom>
              예약신청
            </Typography>
            <DatePickerWrapper>
              <DatePicker
                selectsRange
                monthsShown={isMobile ? 1 : 2}
                startDate={reservationForm.dateRange[0]}
                endDate={reservationForm.dateRange[1]}
                onChange={(update: [Date | null, Date | null]) => {
                  setReservationForm((prev) => ({
                    ...prev,
                    dateRange: update,
                  }));
                  if (update[1]) {
                    setTimeout(() => {
                      const element = document.querySelector('.react-datepicker__input-container input');
                      if (element) {
                        (element as HTMLElement).blur();
                      }
                    }, 100);
                  }
                }}
                dateFormat="yyyy/MM/dd"
                locale={ko}
                minDate={new Date()}
                placeholderText="날짜를 선택하세요"
                isClearable
                showPopperArrow={false}
                calendarStartDay={1}
                customInput={<TextField fullWidth label="여행 기간" size="small" />}
                dayClassName={(date) => {
                  const today = new Date();
                  if (date.toDateString() === today.toDateString()) {
                    return 'today-date';
                  } else if (date < today) {
                    return 'past-date';
                  }
                  return '';
                }}
              />
            </DatePickerWrapper>
            <Stack direction="row" spacing={1}>
              <StyledTextField
                label="성인"
                type="number"
                value={reservationForm.성인수}
                onChange={(e) =>
                  setReservationForm((prev) => ({
                    ...prev,
                    성인수: parseInt(e.target.value) || 0,
                  }))
                }
                InputProps={{
                  startAdornment: <PersonIcon sx={{ color: 'action.active', mr: 1, fontSize: 20 }} />,
                  inputProps: { min: 0 },
                }}
              />
              <StyledTextField
                label="소아"
                type="number"
                value={reservationForm.소아수}
                onChange={(e) =>
                  setReservationForm((prev) => ({
                    ...prev,
                    소아수: parseInt(e.target.value) || 0,
                  }))
                }
                InputProps={{
                  startAdornment: <PersonIcon sx={{ color: 'action.active', mr: 1, fontSize: 20 }} />,
                  inputProps: { min: 0 },
                }}
              />
              <StyledTextField
                label="유아"
                type="number"
                value={reservationForm.유아수}
                onChange={(e) =>
                  setReservationForm((prev) => ({
                    ...prev,
                    유아수: parseInt(e.target.value) || 0,
                  }))
                }
                InputProps={{
                  startAdornment: <PersonIcon sx={{ color: 'action.active', mr: 1, fontSize: 20 }} />,
                  inputProps: { min: 0 },
                }}
              />
            </Stack>
            <StyledTextField
              label="이름"
              value={reservationForm.요청자명}
              onChange={(e) =>
                setReservationForm((prev) => ({
                  ...prev,
                  요청자명: e.target.value,
                }))
              }
            />
            <StyledTextField
              label="휴대폰"
              value={reservationForm.요청자휴대폰}
              onChange={(e) =>
                setReservationForm((prev) => ({
                  ...prev,
                  요청자휴대폰: e.target.value,
                }))
              }
              InputProps={{
                startAdornment: <PhoneIcon sx={{ color: 'action.active', mr: 1, fontSize: 20 }} />,
              }}
            />
            <StyledTextField
              label="이메일"
              value={reservationForm.요청자이메일}
              onChange={(e) =>
                setReservationForm((prev) => ({
                  ...prev,
                  요청자이메일: e.target.value,
                }))
              }
              InputProps={{
                startAdornment: <EmailIcon sx={{ color: 'action.active', mr: 1, fontSize: 20 }} />,
              }}
            />
            <TextField
              label="추가 요청사항"
              multiline
              rows={4}
              value={reservationForm.견적내용}
              onChange={(e) =>
                setReservationForm((prev) => ({
                  ...prev,
                  견적내용: e.target.value,
                }))
              }
            />
            <Button
              variant="contained"
              fullWidth
              size="large"
              onClick={handleReservationSubmit}
              sx={{
                height: '48px',
                fontSize: '16px',
                fontWeight: 'bold',
              }}
              disabled={!isReservationButtonEnabled()}>
              예약 신청하기
            </Button>
          </Stack>
        </DialogContent>
      </MobileReservationDialog>

      <Dialog
        open={shareConfirmDialog}
        onClose={handleCancelShare}
        aria-labelledby="share-confirm-dialog"
        PaperProps={{
          sx: {
            width: '400px',
            borderRadius: '16px',
            bgcolor: '#2F3136',
            color: 'white',
            boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.25)',
          },
        }}>
        <DialogContent sx={{ p: 3, textAlign: 'center' }}>
          <Typography
            variant="h6"
            sx={{
              fontSize: '18px',
              fontWeight: 'medium',
              mb: 3,
            }}>
            선택한 일정을 내 일정표에 추가하시겠습니까?
          </Typography>
        </DialogContent>
        <DialogActions sx={{ p: 3, pt: 0, gap: 1, justifyContent: 'center' }}>
          <Button
            onClick={handleCancelShare}
            sx={{
              borderRadius: '8px',
              height: '42px',
              px: 3,
              color: 'white',
              '&:hover': {
                backgroundColor: 'rgba(255, 255, 255, 0.1)',
              },
            }}>
            취소
          </Button>
          <Button
            onClick={handleConfirmShare}
            variant="contained"
            sx={{
              borderRadius: '8px',
              height: '42px',
              px: 3,
              bgcolor: '#5865F2',
              '&:hover': {
                bgcolor: '#4752C4',
              },
            }}>
            확인
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default PreviewPage;
